import { Link, useLocation, useNavigate } from "react-router-dom";
import { BarChart3, LayoutGrid, LogOut, Receipt, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { FallbackBanner } from "@/components/FallbackBanner";

const NAV = [
  { to: "/staff", label: "Pipeline", icon: LayoutGrid, testId: "nav-pipeline" },
  { to: "/staff/reports", label: "Reports", icon: BarChart3, testId: "nav-reports" },
  { to: "/staff/invoices", label: "Invoices", icon: Receipt, testId: "nav-invoices" },
  { to: "/staff/admin", label: "Access", icon: Users, testId: "nav-admin" },
];

export function StaffLayout({ children }) {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="app-shell">
      <header className="sticky top-0 z-40 glass-strong border-b border-white/10">
        <div className="mx-auto flex max-w-[1600px] items-center gap-8 px-6 lg:px-10 py-4">
          <Link to="/staff" className="font-display text-lg tracking-[0.3em] text-gold">
            VINEFORD
          </Link>
          <nav className="flex items-center gap-1">
            {NAV.map(({ to, label, icon: Icon, testId }) => {
              const active = pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  data-testid={testId}
                  className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm transition-colors ${
                    active ? "bg-gold/15 text-gold" : "text-[#9CA3AF] hover:bg-white/5 hover:text-[#F3F4F6]"
                  }`}
                >
                  <Icon className="h-4 w-4" /> <span className="hidden sm:inline">{label}</span>
                </Link>
              );
            })}
          </nav>
          <div className="ml-auto flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm text-[#F3F4F6]">{user?.name}</p>
              <p className="text-[11px] uppercase tracking-widest text-gold">{user?.role}</p>
            </div>
            <button
              data-testid="logout-btn"
              onClick={() => {
                logout();
                navigate("/login", { replace: true });
              }}
              className="rounded-full border border-white/15 p-2 text-[#9CA3AF] hover:border-gold/50 hover:text-gold transition-colors"
              aria-label="Sign out"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1600px] px-6 lg:px-10 py-8 space-y-8">
        <FallbackBanner />
        {children}
      </main>
    </div>
  );
}
